
import { defineComponent, ref, watch, computed } from "vue";
import { FormDialog } from "@/components/Common";
import { useRouter } from "vue-router";
import { useStore } from "vuex"
import {useDialogCommon, useDialogFormData, useDynamicDialog} from "@/hooks";
import { initFormData, PLATFORM_AUTHORIZE_LINK } from "./BesBindEditData";
import _ from "lodash";

import {
  SmsCode,
  GetMerchantSheetPhoneList,
  MerchantSheetBinding,
  GetState,
  OnlineAuthorization,
  GetGraphicCode,
  AddElectronicSetInfo,
  QuerySiteElectronicSetInfo,
  SmsBingElectronic
} from "@/api-server/modules/defaultServer";
import {ElMessage, ElMessageBox} from "element-plus";
import { mobileReg } from "@/utils/regs";
import reminder from './reminder.vue'
export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    canClose: { type: Boolean, default: true },
    formData: {
      type: Object,
      default: () => ({ ...initFormData }),
    },
  },

  components: {
    FormDialog,
    reminder
  },

  emits: ["update:visible", "updateSuccess"],

  setup(props, context) {
    const router = useRouter()
    const store = useStore()
    const { visibleRef } = useDialogCommon(props, context);
    const { editFormData } = useDialogFormData(props, initFormData, {
      type: "resetWithPropsFormData",
      visiableRef: visibleRef,
    });
    const formDialogRefs = ref<any>(null);
    console.log(props, editFormData)
    const options = ref([
      {
        value: 'ZTO|中通快递',
        label: '中通快递'
      },
      {
        value: 'SF|顺丰快递',
        label: '顺丰快递'
      },
      {
        value: 'ZJS|宅急送',
        label: '宅急送'
      },
      {
        value: 'ST|申通快递',
        label: '申通快递'
      },
      {
        value: 'YT|圆通快递',
        label: '圆通快递'
      },
      {
        value: 'YD|韵达快递',
        label: '韵达快递'
      },
      {
        value: 'EMS|EMS',
        label: 'EMS'
      },
      {
        value: 'BEST|百世汇通',
        label: '百世汇通'
      },
      {
        value: 'YZKDBG|邮政快递包裹',
        label: '邮政快递包裹',
        placeholderID: '请输入合作网点提供的客户代码',
        warning: '电子面单账号是快递网点给您开通来获取电子面单的客户代码，具体咨询合作快递网点即可'
      },
      {
        value: 'JT|极兔速递',
        label: '极兔速递',
        placeholderID: '请输入合作网点提供的客户编码',
        placeholderPass: '请输入客户密码',
        warning: '电子面单账号和密钥是快递网点给您开通来获取电子面单的账号和密钥，具体咨询合作快递网点即可'
      },
      {
        value: 'YSKD|优速快递',
        label: '优速快递',
        placeholderID: '请输入合作网点提供的客户编码',
        placeholderPass: '请输入客户密码',
        warning: '电子面单账号和密钥是快递网点给您开通来获取电子面单的账号和密钥，具体咨询合作快递网点即可'
      },
      {
        value: 'JD|京东快递',
        label: '京东快递',
        placeholderID: '请输入合作网点提供的客户代码',
        warning: '电子面单账号是快递网点给您开通来获取电子面单的客户代码，具体咨询合作快递网点即可'
      },
      {
        value: 'DBWL|德邦快递',
        label: '德邦快递',
        placeholderMc: '请输入德邦月结号',
        warning:
            '1.如果您是普通散户，就不需要维护账号可直接打单。\n2.如果您是月结客户，需要维护月结账号，账号名称就是德邦月结号。\n3.快递管家无法验证除中通外其他物流公司账号密码的正确性，建议保存后，使用该账号打印一个快递单进行验证。'
      },
      {
        value: 'KYSY|跨越速运',
        label: '跨越速运',
        placeholderID: '请输入合作网点提供的客户代码',
        warning: '电子面单账号是快递网点给您开通来获取电子面单的客户代码，具体咨询合作快递网点即可'
      },
      {
        value: 'FWSY|丰网速运',
        label: '丰网速运',
        placeholderID: '请输入合作网点提供的客户编码',
        placeholderPass: '请输入客户密码',
        warning: '商家ID和密钥是快递网点给您开通来获取电子面单的账号和密钥，具体咨询合作快递网点即可'
      },
      {
        value: 'SURE|速尔快递',
        label: '速尔快递',
        placeholderID: '请输入合作网点提供的客户编号',
        warning: '电子面单账号是快递网点给您开通来获取电子面单的客户号，网点编号与收件快递员请具体咨询合作快递网点即可'
      },
      {
        value: 'DNWL|丹鸟物流',
        label: '丹鸟物流',
        placeholderID: '请输入合作网点提供的客户编码',
        placeholderPass: '请输入客户密码',
        warning: '电子面单账号和密钥是快递网点给您开通来获取电子面单的账号和密钥，具体咨询合作快递网点即可'
      },
      {
        value: 'SNWL|苏宁物流',
        label: '苏宁物流',
        placeholderID: '请输入合作网点提供的客户编码',
        placeholderPass: '请输入客户密码',
        warning: '电子面单账号和密钥是快递网点给您开通来获取电子面单的账号和密钥，具体咨询合作快递网点即可'
      },
      {
        value: 'ZYKD|众邮快递',
        label: '众邮快递',
        placeholderID: '请输入合作网点提供的客户编号',
        warning: '电子面单账号是快递网点给您开通来获取电子面单的客户号，具体咨询合作快递网点即可'
      },
      {
        value: 'YCKY|远成快运',
        label: '远成快运',
        placeholderID: '请输入合作网点提供的客户名称',
        warning: '电子面单账号是快递网点给您开通来获取电子面单的客户号，具体咨询合作快递网点即可'
      },
      {
        value: 'XFWL|信丰物流',
        label: '信丰物流',
        placeholderID: '请输入合作网点提供的客户名称',
        warning: '电子面单账号是快递网点给您开通来获取电子面单的客户号，具体咨询合作快递网点即可'
      }
    ])
    const checkAll =ref(true)
    const isIndeterminate =ref(false)
    const newguide = ref(store.state.config.apollo.newguide)
    const rules = {
      partnerId: [
        { required: true, message: "请输入电子面单账号", trigger: "blur" },
      ],
      mobile: [
        {
          required: true,
          message: "手机号不能为空",
          trigger: ["blur", "change"],
        },
      ],
      img_code: [
        { required: true, message: "请输入图形验证码", trigger: "blur" },
      ],
      mobile_code: [
        { required: true, message: "请输入验证码", trigger: "blur" },
      ],
      password: [{ required: true, message: "请输入密钥", trigger: "blur" }],
      siteCode: [
        {
          required: true,
          message: "请选择服务网点",
          trigger: ["blur", "change"],
        },
      ],
      siteCodeList: [
        // {
        //   required: true,
        //   validator: (rule: any, value: any, callback: any) => {
        //     if (value.length <=0 ) {
        //       return callback(new Error("请选择要绑定的网点"));
        //     }else{
        //       return callback();
        //     }
        //   },
        // }
      ],
      receiveCourier: [{ required: true, message: '请输入收件快递员', trigger: 'blur' }],
      customerPlatformId: [{ required: true, message: '请输入客户平台ID', trigger: 'blur' }],
      customerPlatformYzm: [{ required: true, message: '请输入客户平台验证码', trigger: 'blur' }],
      customerBusinessId: [{ required: true, message: '请输入客户商号ID或仓库ID', trigger: 'blur' }]
    };
    const rules_mobile = {
      partnerId: [
        { required: true, message: "请输入电子面单账号", trigger: "blur" },
      ],
      mobile: [
        {
          required: true,
          message: "手机号不能为空",
          trigger: ["blur", "change"],
        },
        {
          pattern: mobileReg,
          message: "手机号不符合格式",
          trigger: "blur",
        },
      ],
      mobile_code: [
        { required: true, message: "请输入验证码", trigger: "blur" },
      ],
      password: [{ required: true, message: "请输入密钥", trigger: "blur" }],
      siteCode: [
        {
          required: true,
          message: "请选择服务网点",
          trigger: ["blur", "change"],
        },
      ],
      receiveCourier: [{ required: true, message: '请输入收件快递员', trigger: 'blur' }],
      customerPlatformId: [{ required: true, message: '请输入客户平台ID', trigger: 'blur' }],
      customerPlatformYzm: [{ required: true, message: '请输入客户平台验证码', trigger: 'blur' }],
      customerBusinessId: [{ required: true, message: '请输入客户商号ID或仓库ID', trigger: 'blur' }]
    };
    const chooseType = ref("flag_select");
    const mobileOptions = ref<any>('');
    const siteCodeOptions = ref<any[]>([]);
    const online = ref(true);
    const orderType = ref<any>('');
    const validateList = ref<any>([]);
    const imgCodeUrl = ref('')
    const imgCodeUrlId = ref('')
    const time = ref(60)
    const timer = ref<any>(null)
    const btnText = ref('获取验证码')
    const reminderDataList = ref([
          {
            information: '电子面单账号和密钥是快递网点给您开通来获取电子面单的账号和密钥，具体咨询合作快递网点即可',
            _href: '',
            text: ''
          },
          {
            information:
                '1.如果您是普通散户，就不需要维护账号可直接打单。\n2.如果您是月结客户，需要维护月结账号，账号名称就是顺丰月结号。\n3.快递管家无法验证除中通外其他物流公司账号密码的正确性，建议保存后，使用该账号打印一个快递单进行验证。',
            _href: '',
            text: ''
          },
          {
            information: '电子面单账号和密钥是快递网点给您开通来获取电子面单的账号和密钥，具体咨询合作快递网点即可',
            _href: '',
            text: ''
          },
          {
            information: '如果您是普通散户，就不需维护直接打单即可',
            _href: '',
            text: ''
          },
          {
            information:
                '1.如果您是普通散户，就不需要维护账号可直接打单。\n2.如果您是大客户，需要维护电子面单账号，账号名称就是大客户号。\n3.快递管家无法验证除中通外其他物流公司账号密码的正确性，建议保存后，使用该账号打印一个快递单进行验证。',
            _href: '',
            text: ''
          }
        ])
    const calCurExpress = computed(() => {
      if (editFormData.value.expressName) {
        // 新增
        return options.value.find(item => item.value === editFormData.value.expressName)
      }
      return ''
    })
    const calShowVerifyType = computed(() => {
      return ![
        'ZJS|宅急送',
        'YZKDBG|邮政快递包裹',
        'JD|京东快递',
        'KYSY|跨越速运',
        'SURE|速尔快递',
        'ZYKD|众邮快递',
        'YCKY|远成快运',
        'XFWL|信丰物流'
      ].includes(editFormData.value.expressName)
    })
    const calLocationOrigin = computed(() => {
      return window.location.origin
    })
    const placeholderPass = ref('')
    const placeholderID = ref('')
    initImgCode()
    function chooseTypeChange() {
      formDialogRefs.value.clearValidate()
    }
    function selectChangeExpress(val:any) {
      console.log(val)
      orderType.value = 1
      if (val !== 'ZTO|中通快递') {
        chooseType.value = 'flag_input'
      } else {
        chooseType.value = 'flag_select'
      }
      if (val === 'ZJS|宅急送') {
        placeholderID.value = '请输入合作网点提供的大客户号'
      } else if (val === 'ZTO|中通快递') {
        placeholderID.value = '请输入合作网点提供的面单账号'
        placeholderPass.value = '请输入面单账号对应的密钥'
      } else if (val === 'ST|申通快递') {
        placeholderID.value = '请输入合作网点提供的客户名称'
        placeholderPass.value = '请输入客户密码'
      } else {
        placeholderID.value = '请输入合作网点提供的客户编码'
        placeholderPass.value = '请输入客户编码对应的密钥'
      }
      const result:any = calCurExpress
      console.log('result ==================', result?.placeholderID)
      if (result) {
        if (result.placeholderID) placeholderID.value = result.placeholderID
        if (result.placeholderPass) placeholderPass.value = result.placeholderPass
      }
    }
    async function startVerify() {
      validateList.value = [];
      formDialogRefs.value &&
      formDialogRefs.value.validateField(
          chooseType.value == "flag_select"
              ? ["partnerId", "siteCode", "mobile", "img_code"]
              : ["mobile"],
          (errorMessage: string) => {
            validateList.value.push(errorMessage);
          }
      );
      let flag = validateList.value.every((item: string) => {
        return item == "";
      });
      if (!flag) {
        return;
      }
      const params = {
        electronic: editFormData.value.partnerId,
        siteCode: editFormData.value.siteCode,
        picId: imgCodeUrlId.value,
        code: editFormData.value.img_code, // 图形验证码
      }
      const res: any = await SmsCode.fetch(params)
      console.log(res)
      if (res.data.status) {
        ElMessage.success({ showClose: true, message: "短信发送成功" });
        timer.value = setInterval(() => {
          if (time.value === 0) {
            clearInterval(timer.value)
            time.value = 60
          } else {
            time.value--
          }
        }, 1000)
      } else {
        ElMessage.warning({ showClose: true, message: res.data.message });
      }
    }
    function selectChangeSite(siteCode: any) {
      const findOne = siteCodeOptions.value.find((item: any) => item.siteCode === siteCode)
      console.log('findOne:', findOne)
      editFormData.value.siteCode = findOne ? findOne.siteCode : ''
      editFormData.value.siteName = findOne ? findOne.siteName : ''
      orderType.value = findOne ? findOne.orderType : ''
      editFormData.value.mobile = findOne ? findOne.linkeMobile : ''
    }
    // 获取验证图片
    function initImgCode() {
      GetGraphicCode.fetch({ type: 1 }).then((res: any) => {
        console.log('res', res)
        if (res.data.status) {
          imgCodeUrl.value = res.data.result.image
          imgCodeUrlId.value = res.data.result.picId
        } else {
          ElMessage.warning({ showClose: true, message: res.data.message });
        }
      })
    }
    async function saveFormHandle() {
      if (chooseType.value === "flag_select") {
        const params = {
          electronic: editFormData.value.partnerId,
          siteCode: editFormData.value.siteCode,
          code: editFormData.value.mobile_code,
        }
        const res: any = await SmsBingElectronic.fetch(params)
        if (!res.data.status) {
          ElMessage.warning({ showClose: true, message: res.data.message });
          return
        }
      } else {
        if (
            editFormData.value.expressName === 'SF|顺丰快递' ||
            editFormData.value.expressName === 'DBWL|德邦快递'
        ) {
          // 月结号当秘钥校验
          editFormData.value.password = editFormData.value.monthCount
          // 月结号当账号展示
          editFormData.value.partnerId = editFormData.value.monthCount
        }
        if (editFormData.value.expressName === 'EMS|EMS') {
          editFormData.value.partnerId = editFormData.value.bigCustomerNum
        }
        const params = {
          companyId: editFormData.value.partnerId,
          siteCode: editFormData.value.siteCode,
          siteName: editFormData.value.siteName,
          interSecret: editFormData.value.password,
          expressName: editFormData.value.expressName,
          orderType: orderType.value || 1,
          receiveCourier: editFormData.value.receiveCourier,
          customerPlatformId: editFormData.value.customerPlatformId,
          customerPlatformYzm: editFormData.value.customerPlatformYzm,
          customerBusinessId: editFormData.value.customerBusinessId
          // orderType: orderType.value, // 面单类型
          // expressName: 'ZTO|中通快递', // 物流公司
          // companyId: editFormData.value.partnerId, // 电子面单账号
          // siteCode: editFormData.value.siteCode,
          // siteName: editFormData.value.siteName,
          // interSecret: editFormData.value.password,
        }
        const res: any = await AddElectronicSetInfo.fetch(params)
        console.log('res', res)
        if (!res.data.status) {
          ElMessage.warning({ showClose: true, message: res.data.message });
          return
        }
      }
      ElMessage.success({ showClose: true, message: "绑定成功" });
      clearInterval(timer.value)
      if (editFormData.value.expressName === 'ZTO|中通快递' && online.value) {
        ElMessageBox.confirm(
            '若您想用快递管家打单发货，请前往店铺授权。',
            '店铺授权',
            {
              confirmButtonText: '去授权',
              cancelButtonText: '稍后再说',
              type: 'warning',
            }
        ).then(async () => {
          authorization()
        }).catch(() => {
          console.log('稍后再说')
          visibleRef.value = false;
          context.emit("updateSuccess");
        })
      } else {
        visibleRef.value = false;
        context.emit("updateSuccess");
      }


      // if (chooseType.value == "flag_input") {
      //   await ValidatePartnerPwd.fetch({
      //     partnerId: editFormData.value.partnerId,
      //     password: editFormData.value.password,
      //     netDot: editFormData.value.siteCode,
      //   });
      // }
      // const params = {
      //   bindType: chooseType.value == "flag_select" ? "1" : "2",
      //   partnerId: editFormData.value.partnerId,
      //   updateMerchantSheetPhoneQry: {
      //     siteCode: editFormData.value.siteCode,
      //     linkManMobile: editFormData.value.mobile,
      //   },
      //   enable: 1,
      //   siteCodeList: editFormData.value.siteCodeList,
      // };
      //
      // await MerchantSheetBinding.fetch(
      //   chooseType.value == "flag_input"
      //     ? {
      //         ...params,
      //         password: editFormData.value.password,
      //         netDot: editFormData.value.siteCode,
      //       }
      //     : {
      //       ...params,
      //       veriCodeMessageCheckCmd: {
      //         mobile: editFormData.value.mobile,
      //         mobile_code: editFormData.value.mobile_code,
      //       },
      //     }
      // );
      // ElMessage.success({ showClose: true, message: "绑定成功" });
      // clearInterval(timer.value)
      // visibleRef.value = false;
      // context.emit("updateSuccess");
    }
    function authorization() {
      console.log('orderType:', orderType.value)
      let platformId = ''
      switch (Number(orderType.value)) {
        case 1:
          platformId = 'LocalOffline'
          break
        case 2:
          platformId = 'TaoBao'
          break
        case 3:
          platformId = 'Jd'
          break
        case 5:
          platformId = 'Pdd'
          break
        case 6:
          platformId = 'LuBan'
          break
        case 7:
          platformId = 'KuaiShou'
          break
        default:
          platformId = ''
          break
      }
      let newWin = window.open(window.location.origin)
      authLogin(platformId, newWin)
    }
    //授权登录
    function authLogin(platformId: string, winForm: any) {
      let getStateParam = { requestType: 1, platformId: platformId }
      GetState.fetch(getStateParam).then((res: any) => {
        let param = { sessionId: res.data.result }
        console.log('param', param)
        let url = PLATFORM_AUTHORIZE_LINK[platformId]
        if (url) {
          url = url.replace('${sessionId}', res.data.result)
          console.log('url:', url)
          winForm.location.href = url
          visibleRef.value = false;
          context.emit("updateSuccess");
          return
        }
        OnlineAuthorization.fetch(param).then((res: any) => {
          if (res.data.status) {
            ElMessage.success({ showClose: true, message: "授权成功" });
            // this.$message('授权成功')
            // alert("授权成功");
            router.push('/admin/after-sales/afterSales-workOrder')
            // this.$router.push({ path: '/settings/store' })
          } else {
            ElMessage.warning({ showClose: true, message: "授权失败" });
            // this.$message('授权失败')
            //alert("授权失败");
          }
        })
      })
    }
    async function partnerIdChange(partnerId: string) {
      if (!partnerId) {
        if (chooseType.value == "flag_select") {
          editFormData.value.mobile = "";
        }
        editFormData.value.siteCode = "";
        mobileOptions.value = '';
        siteCodeOptions.value = [];
        return;
      }
      const data: any = await QuerySiteElectronicSetInfo.fetch({
        companyId: partnerId,
      });
      console.log('data:', data)
      siteCodeOptions.value = data.data?.result || [];
      editFormData.value.mobile = data.data?.result[0]?.linkeMobile || '';
      online.value = data.data?.result[0]?.online || false;
      orderType.value = data.data?.result[0]?.orderType || '';
      if (data.data?.result?.length === 1) {
        editFormData.value.siteCode = data.data.result[0].siteCode || '';
        selectChangeSite(data.data.result[0].siteCode)
      }
      // checkAll.value = true
      chooseType.value = 'flag_select'
      // handleCheckAllChange(true)
    }

    function sendVeriMessage() {
      return new Promise((resolve, reject) => {
        validateList.value = [];
        formDialogRefs.value &&
        formDialogRefs.value.validateField(
            chooseType.value == "flag_select"
                ? ["partnerId", "mobile"]
                : ["mobile"],
            (errorMessage: string) => {
              validateList.value.push(errorMessage);
            }
        );
        let flag = validateList.value.every((item: string) => {
          return item == "";
        });
        if (!flag) {
          return;
        }
        if (chooseType.value == "flag_select") {
          resolve({
            sendType: "bindPartnerId",
            mobile: editFormData.value.mobile,
            partnerId: editFormData.value.partnerId,
          });
        } else {
          resolve({
            sendType: "cooperation",
            mobile: editFormData.value.mobile,
          });
        }
      });
    }

    function handleCheckAllChange(val: boolean) {
      editFormData.value.siteCodeList = val ? siteCodeOptions.value.map(v => v.siteCode) : [];
      isIndeterminate.value = false;
    }

    function handleCheckedChange(value: string[]) {
      let checkedCount = value.length;
      checkAll.value = checkedCount === siteCodeOptions.value.length;
      isIndeterminate.value = checkedCount > 0 && checkedCount < siteCodeOptions.value.length;
    }

    watch(
        () => editFormData.value.partnerId,
        _.debounce(async (partnerId) => {
          partnerIdChange(partnerId);
        }, 1000),
        { immediate: true }
    );
    watch(
        () => chooseType.value,
        (n: string) => {
          editFormData.value.mobile = "";
          editFormData.value.mobile_code = "";
          if (n == "flag_select") {
            editFormData.value.password = "";
            editFormData.value.siteCode = "";
          }
        }
    );
    watch(
        () => visibleRef.value,
        (n: boolean) => {
          if (!n) {
            chooseType.value = "flag_select";
          }
        }
    );

    return {
      chooseTypeChange,
      calShowVerifyType,
      calLocationOrigin,
      reminderDataList,
      calCurExpress,
      selectChangeExpress,
      options,
      startVerify,
      btnText,
      time,
      selectChangeSite,
      imgCodeUrl,
      initImgCode,
      formDialogRefs,
      rules,
      rules_mobile,
      visibleRef,
      editFormData,
      saveFormHandle,
      chooseType,
      mobileOptions,
      siteCodeOptions,
      online,
      partnerIdChange,
      sendVeriMessage,
      validateList,
      checkAll,
      isIndeterminate,
      handleCheckAllChange,
      handleCheckedChange,
      authorization,
      newguide
    };
  },
});
